module.exports = __webpack_public_path__ + "static/img/8.89b6eca1.gif";